module.exports = __webpack_public_path__ + "static/media/PDF18.bc227678.pdf";